import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { linkStyleOverride } from '../Link/Link';
import { theme } from '../theme';
import { fontStyleMapping } from './fontMapping';
export const Text = forwardRef(({ children, typo = 'body-regular', className = '', tag = 'p', align = 'left', color = 'liquorice', cursor = 'inherit', title = '', ...props }, ref) => (React.createElement(Container, { forwardedAs: tag, className: className, "$typo": typo, "$align": align, "$color": color, cursor: cursor, title: title, ...props, ref: ref }, children)));
Text.displayName = 'Text';
const isTypo = (value) => {
    return Object.keys(fontStyleMapping).includes(value);
};
const Container = styled(Box)(({ $align, $color, $cursor, $typo }) => css `
    /** TYPOGRAPHY STYLES */

    ${isTypo($typo) && fontStyleMapping[$typo]}

    text-align: ${$align};
    cursor: ${$cursor};
    color: ${theme.colors[$color]};
    ${linkStyleOverride({ color: theme.colors[$color] })}
  `);
//# sourceMappingURL=Text.js.map